/***
 * @file:
 * @author: haoxianhuan
 * @Date: 2021-08-14 14:54:39
 */

import { NgModule } from '@angular/core';
import { QUILL_CONFIG_TOKEN, QuillModule } from 'ngx-quill';
import { EditorRichComponent } from './editor-rich.component';
const COMPONENTS = [EditorRichComponent];
// ngx-quill QuillModule.forRoot æ¹æ³æé®é¢ï¼éå
const EditorModule = {
  ngModule: QuillModule,
  providers: [
    {
      provide: QUILL_CONFIG_TOKEN,
      useValue: {
        modules: {
          syntax: true,
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ direction: 'rtl' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
            ['clean'],
            ['link', 'image'], // link and image, video
          ],
        },
      },
    },
  ],
};

@NgModule({
  imports: [EditorModule],
  providers: [],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class EditorRichModule {}
